import {Grid} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {ReactElement} from 'react'

import {renderWidget} from '../../index'
import type {SectionProps as Props} from '../../types'
import * as classes from './VerticalsSection@mobile.classes'

export function VerticalsSection({section}: Props): ReactElement {
  const i18n = useI18n()

  return (
    <>
      <Grid xs={12} item>
        <div className={classes.wrapper.formTitle}>
          <span className={classes.formTitle}>{i18n('order.form.verticals.title', 'Новый заказ')}</span>
        </div>
      </Grid>
      {section.widgets.map(renderWidget)}
    </>
  )
}
